import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";

import { moduleName as recordsModuleName } from "../records";
import { routeConfig } from "./routes";
import {
  vsComponentName as ContractInstancesComponentName,
  contractInstanceComponentOptions,
} from "./views/Instances";

import {
  vsComponentName as contractInfoComponentName,
  contractInfoComponentOptions,
} from "./views/info";

import {
  vsDirectiveName as contractInfoDirectiveName,
  contractDetailDirectiveFactory,
} from "./views/info/contractInfoDirective";
import {
  contractRelationshipsComponentOptions,
  vsComponentName as contractRelationshipsComponentName,
} from "./views/relationships/contractRelationships";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../records/server/serverUtility";
import { Record } from "../records/server/crud";
import {
  ContractServiceProvider,
  vsProviderName as ContractServiceProviderName,
} from "./shared/ContractService";
import { vsModuleName as contractSharedModule } from "./shared";

export const vsName = "SlotTrak.Contract";

angular
  .module(
    vsName,
    [uiRouter, recordsModuleName, contractSharedModule],
    [
      ContractServiceProviderName,
      (contractServiceProvider: ContractServiceProvider) => {
        contractServiceProvider.addContractTab({
          name: "Relationships",
          state: {
            url: "/relationships",
            views: { tabs: { component: contractRelationshipsComponentName } },
            resolve: {
              contractRelationships: [
                ServerUtilityName,
                "contract",
                (serverUtility: ServerUtility, contract: Record) =>
                  serverUtility.sendApiRequest({
                    method: "get",
                    url: `/api/contract/${contract.ContractInstanceId}/relationships`,
                  }),
              ],
            },
          },
          uiSref: "relationships",
        });
      },
    ]
  )
  .config(routeConfig)
  .directive(contractInfoDirectiveName, contractDetailDirectiveFactory)
  .component(contractInfoComponentName, contractInfoComponentOptions)
  .component(ContractInstancesComponentName, contractInstanceComponentOptions)
  .component(
    contractRelationshipsComponentName,
    contractRelationshipsComponentOptions
  );

export default vsName;
